window.addEventListener('load', function() {

    const scrollSpeed = 0.0419;
    const pauseAtEdge = 5000;

    let DIRECTION = 1; // scrolling down

    // only scroll the view if the 'refresh' meta tag has been set in the HTML page since
    // page scrolling and page refreshing are always present/absent together on the ranking page
    if (document.getElementById('meta-http-refresh')) {
        setTimeout(scroll, 0);
    }

    function scroll() {
        let previousTimestamp = performance.now();

        function step(currentTimestamp) {
            const scrollingDown = isScrollingDown();

            const distance = (currentTimestamp - previousTimestamp) * scrollSpeed;
            const newY = scrollingDown ? window.pageYOffset + distance : window.pageYOffset - distance;

            window.scrollTo(0, Math.round(newY));

            const targetY = scrollingDown ? document.body.scrollHeight - viewPortHeight() : 0;
            const edgeReached = scrollingDown ? window.pageYOffset >= targetY : window.pageYOffset <= targetY;

            if (edgeReached) {
                flipDirection();
                setTimeout(scroll, pauseAtEdge)
            } else {
                previousTimestamp = currentTimestamp;
                window.requestAnimationFrame(step);
            }
        }

        window.requestAnimationFrame(step);
    }

    function isScrollingDown() {
        return DIRECTION === 1;
    }

    function flipDirection() {
        DIRECTION = DIRECTION * -1;
    }

    function viewPortHeight() {
        return window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;
    }

});
